module.exports = __webpack_public_path__ + "media/images/players/LEISHMAN_MARC-94349f017f34d38bddd13c795bdbab64.png";